/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthorizationLeadWaitlistDetails } from './PalAuthorizationLeadWaitlistDetails';
import {
    PalAuthorizationLeadWaitlistDetailsFromJSON,
    PalAuthorizationLeadWaitlistDetailsFromJSONTyped,
    PalAuthorizationLeadWaitlistDetailsToJSON,
} from './PalAuthorizationLeadWaitlistDetails';
import type { PalAuthorizationLeadWaitlistStatusSetByUser } from './PalAuthorizationLeadWaitlistStatusSetByUser';
import {
    PalAuthorizationLeadWaitlistStatusSetByUserFromJSON,
    PalAuthorizationLeadWaitlistStatusSetByUserFromJSONTyped,
    PalAuthorizationLeadWaitlistStatusSetByUserToJSON,
} from './PalAuthorizationLeadWaitlistStatusSetByUser';
import type { PalAuthorizationLeadWaitlistUpdatesInner } from './PalAuthorizationLeadWaitlistUpdatesInner';
import {
    PalAuthorizationLeadWaitlistUpdatesInnerFromJSON,
    PalAuthorizationLeadWaitlistUpdatesInnerFromJSONTyped,
    PalAuthorizationLeadWaitlistUpdatesInnerToJSON,
} from './PalAuthorizationLeadWaitlistUpdatesInner';

/**
 * 
 * @export
 * @interface PalAuthorizationLeadWaitlist
 */
export interface PalAuthorizationLeadWaitlist {
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlist
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlist
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlist
     */
    status?: PalAuthorizationLeadWaitlistStatusEnum;
    /**
     * 
     * @type {PalAuthorizationLeadWaitlistDetails}
     * @memberof PalAuthorizationLeadWaitlist
     */
    details?: PalAuthorizationLeadWaitlistDetails;
    /**
     * 
     * @type {number}
     * @memberof PalAuthorizationLeadWaitlist
     */
    rank?: number;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlist
     */
    created_at?: string;
    /**
     * 
     * @type {PalAuthorizationLeadWaitlistStatusSetByUser}
     * @memberof PalAuthorizationLeadWaitlist
     */
    status_set_by_user?: PalAuthorizationLeadWaitlistStatusSetByUser;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlist
     */
    receipt_id?: string;
    /**
     * 
     * @type {Array<PalAuthorizationLeadWaitlistUpdatesInner>}
     * @memberof PalAuthorizationLeadWaitlist
     */
    updates?: Array<PalAuthorizationLeadWaitlistUpdatesInner>;
}


/**
 * @export
 */
export const PalAuthorizationLeadWaitlistStatusEnum = {
    Waitlisted: 'Waitlisted',
    Cleared: 'Cleared',
    Cancelled: 'Cancelled'
} as const;
export type PalAuthorizationLeadWaitlistStatusEnum = typeof PalAuthorizationLeadWaitlistStatusEnum[keyof typeof PalAuthorizationLeadWaitlistStatusEnum];


/**
 * Check if a given object implements the PalAuthorizationLeadWaitlist interface.
 */
export function instanceOfPalAuthorizationLeadWaitlist(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthorizationLeadWaitlistFromJSON(json: any): PalAuthorizationLeadWaitlist {
    return PalAuthorizationLeadWaitlistFromJSONTyped(json, false);
}

export function PalAuthorizationLeadWaitlistFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthorizationLeadWaitlist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'details': !exists(json, 'details') ? undefined : PalAuthorizationLeadWaitlistDetailsFromJSON(json['details']),
        'rank': !exists(json, 'rank') ? undefined : json['rank'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'status_set_by_user': !exists(json, 'status_set_by_user') ? undefined : PalAuthorizationLeadWaitlistStatusSetByUserFromJSON(json['status_set_by_user']),
        'receipt_id': !exists(json, 'receipt_id') ? undefined : json['receipt_id'],
        'updates': !exists(json, 'updates') ? undefined : ((json['updates'] as Array<any>).map(PalAuthorizationLeadWaitlistUpdatesInnerFromJSON)),
    };
}

export function PalAuthorizationLeadWaitlistToJSON(value?: PalAuthorizationLeadWaitlist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'status': value.status,
        'details': PalAuthorizationLeadWaitlistDetailsToJSON(value.details),
        'rank': value.rank,
        'created_at': value.created_at,
        'status_set_by_user': PalAuthorizationLeadWaitlistStatusSetByUserToJSON(value.status_set_by_user),
        'receipt_id': value.receipt_id,
        'updates': value.updates === undefined ? undefined : ((value.updates as Array<any>).map(PalAuthorizationLeadWaitlistUpdatesInnerToJSON)),
    };
}

